// Utilitaire pour tracker les connexions admin
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Détecter le type d'appareil depuis userAgent
 */
const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Détecter le type d'appareil
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
  const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent);
  
  // Détecter le navigateur
  let browser = 'Unknown';
  if (userAgent.indexOf('Firefox') > -1) browser = 'Firefox';
  else if (userAgent.indexOf('Chrome') > -1) browser = 'Chrome';
  else if (userAgent.indexOf('Safari') > -1) browser = 'Safari';
  else if (userAgent.indexOf('Edge') > -1) browser = 'Edge';
  else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) browser = 'Opera';
  
  // Détecter le système d'exploitation
  let os = 'Unknown';
  if (userAgent.indexOf('Windows') > -1) os = 'Windows';
  else if (userAgent.indexOf('Mac') > -1) os = 'macOS';
  else if (userAgent.indexOf('Linux') > -1) os = 'Linux';
  else if (userAgent.indexOf('Android') > -1) os = 'Android';
  else if (userAgent.indexOf('iOS') > -1 || /iPad|iPhone|iPod/.test(userAgent)) os = 'iOS';
  
  let deviceType = 'Desktop';
  if (isMobile) deviceType = 'Mobile';
  else if (isTablet) deviceType = 'Tablet';
  
  return {
    type: deviceType,
    browser,
    os,
    userAgent: userAgent.substring(0, 200) // Limiter la longueur
  };
};

/**
 * Obtenir l'adresse IP de l'utilisateur
 */
const getIPAddress = async () => {
  try {
    // Essayer plusieurs services pour obtenir l'IP
    const services = [
      'https://api.ipify.org?format=json',
      'https://api64.ipify.org?format=json',
      'https://ipapi.co/json/'
    ];
    
    for (const service of services) {
      try {
        // Utiliser AbortController pour timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        
        const response = await fetch(service, { 
          signal: controller.signal 
        });
        clearTimeout(timeoutId);
        
        if (response.ok) {
          const data = await response.json();
          return data.ip || data.query || 'Unknown';
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn(`Service ${service} failed:`, error);
        }
        continue;
      }
    }
    
    return 'Unknown';
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'IP:', error);
    return 'Unknown';
  }
};

/**
 * Enregistrer une connexion admin dans Firestore
 */
export const recordAdminLogin = async (userEmail, userId) => {
  try {
    console.log('🔄 Début de l\'enregistrement de la connexion admin...');
    
    // Vérifier que db est initialisé
    if (!db) {
      console.error('❌ Firestore db n\'est pas initialisé');
      return null;
    }
    
    const deviceInfo = detectDevice();
    console.log('📱 Informations appareil détectées:', deviceInfo);
    
    const ipAddress = await getIPAddress();
    console.log('🌐 Adresse IP récupérée:', ipAddress);
    
    const loginRecord = {
      userEmail: userEmail || 'Unknown',
      userId: userId || 'Unknown',
      ipAddress: ipAddress,
      deviceType: deviceInfo.type,
      browser: deviceInfo.browser,
      operatingSystem: deviceInfo.os,
      userAgent: deviceInfo.userAgent,
      timestamp: Timestamp.now(),
      loginDate: new Date().toISOString()
    };
    
    console.log('📝 Données à enregistrer:', loginRecord);
    
    // Enregistrer dans Firestore
    const loginRecordsRef = collection(db, 'admin-record-login');
    const docRef = await addDoc(loginRecordsRef, loginRecord);
    
    console.log('✅ Connexion admin enregistrée avec succès!', {
      documentId: docRef.id,
      email: userEmail,
      ip: ipAddress,
      device: deviceInfo.type
    });
    
    return loginRecord;
  } catch (error) {
    console.error('❌ Erreur lors de l\'enregistrement de la connexion admin:', error);
    console.error('❌ Détails de l\'erreur:', {
      code: error.code,
      message: error.message,
      stack: error.stack
    });
    // Ne pas bloquer la connexion si l'enregistrement échoue
    return null;
  }
};

